// @ts-check
import React from 'react';

import Chip from '@liquidweb-dev/undercurrent/Chip';
import { pseudoClasses } from '@liquidweb-dev/undercurrent/classes/pseudo';
import CircleFilled from '@liquidweb-dev/undercurrent/icons/custom/CircleFilled';

/** @param {string} status */
const getLevel = (status) => {
	switch (status.toLowerCase()) {
		case 'waiting on customer':
			return 'warning';
		case 'new':
		case 'open':
			return 'success';
		default:
			return 'default';
	}
};

/**
 * @param {object} props
 * @param {string} props.status
 */
const SupportStatusChip = ({ status }) => (
	<Chip
		label={
			status.toLowerCase() === 'waiting on customer'
				? 'Needs attention'
				: status
		}
		color={getLevel(status)}
		icon={
			<CircleFilled
				sx={{
					[pseudoClasses.important]: {
						color: ({ vars }) => {
							const level = getLevel(status);
							if (level === 'default') return vars.palette.uc.bg.strong;

							return vars.palette.uc[level].icon.strong;
						},
					},
				}}
			/>
		}
	/>
);

export default SupportStatusChip;
